import * as yup from 'yup';

export const QUICK_ADD_INITIAL_VALUES = {
    business_name: '',
    description: '',
    functions: [
        {
            name: '',
            description: '',
            priority: 'low',
            kpis: [],
            models: []
        }
    ]
};

const requiredDescription = yup
    .string()
    .trim()
    .required('Description is required');

const kpiSchema = yup.object({
    name: yup
        .string()
        .trim()
        .required('KPI name is required'),
    description: requiredDescription,
    priority: yup.string().default('low'),
    enable_computation: yup.number().default(1)
});

const modelSchema = yup.object({
    name: yup
        .string()
        .trim()
        .required('Model name is required'),
    description: requiredDescription,
    kind: yup.string().default('Forecasting')
});

const functionSchema = yup.object({
    name: yup
        .string()
        .trim()
        .required('Function name is required'),
    description: requiredDescription,
    priority: yup.string().default('low'),
    kpis: yup.array().of(kpiSchema).default([]),
    models: yup.array().of(modelSchema).default([])
});

export const quickAddValidationSchema = yup.object({
    business_name: yup
        .string()
        .trim()
        .required('Business name is required'),
    description: requiredDescription,
    functions: yup
        .array()
        .min(1, 'At least one function is required')
        .of(functionSchema)
        .required('At least one function is required')
});
